function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.364 35.709a4.365 4.365 0 1 1 .002-8.73 4.365 4.365 0 0 1-.002 8.73zm0-7.829a3.474 3.474 0 1 0 0 6.949 3.474 3.474 0 0 0 0-6.949z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.364 33.52a2.179 2.179 0 1 1-.002-4.357 2.179 2.179 0 0 1 .002 4.357zm0-3.438a1.237 1.237 0 1 0 0 2.472 1.237 1.237 0 0 0 0-2.47v-.002zM13.364 35.709a4.365 4.365 0 1 1 .002-8.73 4.365 4.365 0 0 1-.002 8.73zm0-7.829a3.474 3.474 0 1 0 0 6.949 3.474 3.474 0 0 0 0-6.949z",
  fill: "#E4ECFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.364 33.52a2.179 2.179 0 1 1-.002-4.357 2.179 2.179 0 0 1 .002 4.357zm0-3.438a1.237 1.237 0 1 0 0 2.472 1.237 1.237 0 0 0 0-2.47v-.002z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.765 31.36h-2.4v-9.136h72.43l-.12 4.808h-4.387l-.312 1.851-1.827-.156-1-1.6-7.212-.108-.192-.9h-1.358l-9.544 3.534H29.837l-.108-.288a4.58 4.58 0 0 0-4.423-2.945 4.892 4.892 0 0 0-4.24 3.052l-.109.276h-3.305l-.12-.264a4.962 4.962 0 0 0-4.219-3.053 4.673 4.673 0 0 0-4.123 2.74l-.108.264H7.805l-.04 1.924zm-1.514-.866h.65V28.57h1.6a5.576 5.576 0 0 1 4.891-3 5.721 5.721 0 0 1 4.808 3.305h2.176a5.648 5.648 0 0 1 4.9-3.317 5.492 5.492 0 0 1 5.144 3.221h21.347l9.543-3.534h2.043l.2.913 7.055.108 1.022 1.623h.6l.3-1.779h4.28l.071-3.077H6.218l.033 7.461z",
  fill: "#E4ECFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M77.12 23.522H5.82v.865h71.3v-.865zM48.84 28.763h-1.55V25.3h1.55v3.462zm-1.118-.433h.685v-2.6h-.685v2.6zM40.955 28.763h-1.563V25.3h1.563v3.462zm-1.106-.433h.673v-2.6h-.673v2.6zM33.034 28.763h-1.539V25.3h1.54v3.462zm-1.106-.433h.673v-2.6h-.673v2.6zM20.017 28.763h-1.539V25.3h1.539v3.462zm-1.106-.433h.673v-2.6h-.673v2.6zM7.132 29.268h-1.54V24.46h1.54v4.808zm-1.106-.433h.673v-3.99h-.673v3.99zM61.836 28.05h-3.61l-.06-1.261 3.69-1.49-.02 2.752zm-2.4-.852h1.514v-.613l-1.514.613z",
  fill: "#E4ECFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M60.967 30.085h-1.91v-2.85h1.874l.036 2.85zm-1.046-.853h.165v-1.2h-.156l-.009 1.2zM60.967 34.388h-1.91V30.71h1.91v3.678zm-1.046-.865h.18v-1.947h-.18v1.947z",
  fill: "#E4ECFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M61.652 31.6h-3.293v-2.4h3.293v2.4zm-2.4-.866h1.563v-.649h-1.563v.65zM5.264 22.621 5 20.842l-4.351.661L0 17.272l6.214-5.745 3.161-.481 40.95-6.31L56.087 0l3.245.661-2.236 6.971 1.046 6.839-52.878 8.15zm.457-2.777.276 1.791 51.155-7.825-.95-6.19 2.007-6.238L56.315 1l-5.613 4.615L6.615 12.4.93 17.653l.445 2.921 4.346-.73z",
  fill: "#E4ECFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m8.972 11.747-.855.132 1.488 9.658.856-.132-1.489-9.658zM12.235 11.19l-.855.133 1.488 9.658.855-.132-1.488-9.658zM15.408 10.755l-.856.132 1.489 9.658.855-.132-1.488-9.658zM18.621 10.259l-.855.132 1.488 9.658.855-.132-1.488-9.658zM21.899 9.701l-.855.132 1.488 9.658.856-.132-1.49-9.658zM25.101 9.206l-.855.132 1.488 9.658.856-.132-1.489-9.658zM28.282 8.773l-.855.132 1.488 9.658.856-.132-1.49-9.658zM31.5 8.273l-.857.132 1.488 9.658.856-.132L31.5 8.273zM34.752 7.73l-.855.132 1.488 9.658.855-.132-1.488-9.658zM37.931 7.28l-.855.133 1.488 9.658.855-.132-1.488-9.658zM41.147 6.796l-.855.132 1.488 9.658.856-.132-1.489-9.658zM44.365 6.29l-.856.131 1.488 9.658.856-.132-1.488-9.658zM47.629 5.744l-.856.132 1.489 9.658.855-.132-1.488-9.658zM50.796 5.296l-.856.132 1.488 9.658.856-.132-1.488-9.658z",
  fill: "#E4ECFF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m9.602 19.279-4.335.668.131.855 4.337-.668-.133-.855zM55.582 14.123l-1.166-7.572-2.608-1.912.517-.7 2.885 2.127 1.226 7.921-.854.136zM56.652 23.041h-3.606l-2.1-5.853 1.575-.168-1.2-2.224.757-.409 4.574 8.654zm-3.03-.865h1.588l-2.3-4.327-.817.084 1.53 4.243z",
  fill: "#E4ECFF"
});

var SvgDump = function SvgDump(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 36,
    viewBox: "0 0 78 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDump, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dump.36fd76c8.svg";
export { ForwardRef as ReactComponent };